var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfoIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22.84px",
    height: "28.733px",
    viewBox: "0 0 22.84 28.733",
    enableBackground: "new 0 0 22.84 28.733",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE600",
    points: "19.859,23.458 18.786,23.458 4.056,23.458 2.981,23.458 2.981,22.383 2.981,2.15 2.981,1.076  4.056,1.076 18.786,1.076 19.859,1.076 19.859,2.15 19.859,22.383 19.859,23.458  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B555F",
    d: "M21.767,2.15c0.591,0,1.074-0.483,1.074-1.074V1.075C22.841,0.484,22.357,0,21.767,0H1.075 C0.483,0,0,0.484,0,1.075v0.001C0,1.667,0.483,2.15,1.075,2.15h0.831v20.232h-0.83C0.483,22.383,0,22.867,0,23.459 c0,0.59,0.483,1.074,1.075,1.074h9.284c-0.005,0.045-0.014,0.09-0.014,0.137v2.988c0,0.592,0.484,1.075,1.075,1.075 c0.593,0,1.075-0.483,1.075-1.075V24.67c0-0.047-0.008-0.092-0.014-0.137h9.285c0.591,0,1.074-0.484,1.074-1.074 c0-0.592-0.483-1.076-1.074-1.076h-0.832V2.15H21.767z M18.786,22.383H4.056V2.15h14.73V22.383z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoIcon1);
export default __webpack_public_path__ + "static/media/contact-info-icon1.58895318968b8bab09037dc768f207c1.svg";
export { ForwardRef as ReactComponent };